import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@global/Api';
import { RootState } from '@global/store/store';
import { LOCALE_CODES } from '@src/global/types/types';
import { REQUEST_CART, REQUEST_CART_TYPE } from '@global/requests/checkout';

type GetTaxDataResult = {
  response: REQUEST_CART_TYPE;
  language: LOCALE_CODES;
};

export const getTaxData = createAsyncThunk<
  GetTaxDataResult,
  { language: LOCALE_CODES },
  { rejectValue: string }
>('cart/getTaxData', async ({ language }, { rejectWithValue, getState }) => {
  try {
    const { cart } = getState() as RootState;

    const result = await client.query<REQUEST_CART_TYPE>({
      query: REQUEST_CART,
      variables: {
        uid: cart.cartId,
      },
      fetchPolicy: 'no-cache',
    });

    return {
      response: result?.data,
      language: language,
    };
  } catch (error) {
    return rejectWithValue('SERVER ERROR');
  }
});
